module.exports = __webpack_public_path__ + "static/media/c2.5c1ede0a.jpg";